<!-- Content -->
<div class="mb-2 question-title-container">
  <div class="question-title">
    {{ translate.instant('question') }} {{ index !== null ? index : '' }}
    @if (checkedAndCorrect) {
      <i class="fa fa-check"></i>
    }
  </div>
  <small>{{ 'question_type' | translate }} {{ questionType | translate }}</small>
</div>